/* Shorae — « Trouver ma routine ».

   Quatre questions → une routine visage composée à partir de huit soins.

   Principe : un socle commun (nettoyant, crème ou essence, protection solaire)
   auquel s'ajoutent des soins ciblés selon les priorités choisies. Autant de
   questions que de vraies bifurcations : chaque réponse change quelque chose
   au résultat, sinon elle n'aurait pas lieu d'être posée.

   Les produits sont lus depuis le JSON rendu par la section (réglages produit
   de l'éditeur), jamais par leur titre. */

(function () {
  'use strict';

  var ORDER = ['cleanser', 'essence', 'mist', 'vitc', 'antiage', 'eye', 'cream', 'spf'];

  var WHEN = {
    cleanser: 'Matin et soir',
    essence: 'Matin et soir',
    mist: 'Dans la journée',
    vitc: 'Matin',
    antiage: 'Soir',
    eye: 'Matin et soir',
    cream: 'Matin et soir',
    spf: 'Matin'
  };

  var STEPS = ['type', 'sens', 'prio', 'temps'];

  var VALID = {
    type: ['seche', 'grasse', 'normale'],
    sens: ['oui', 'parfois', 'non'],
    prio: ['hydratation', 'eclat', 'age', 'yeux', 'imperfections', 'simple'],
    temps: ['essentiel', 'complet']
  };

  var PRIO_LABEL = {
    hydratation: 'le confort',
    eclat: 'l’éclat',
    age: 'les premiers signes de l’âge',
    yeux: 'le contour des yeux',
    imperfections: 'les imperfections',
    simple: 'l’essentiel'
  };

  var MAX_PRIO = 2;
  var STORE_KEY = 'shorae-rq';

  /* --- Mouvement ----------------------------------------------------------- */

  var EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var EASE_IN = 'cubic-bezier(0.55, 0, 0.75, 0.2)';

  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function canAnimate(el) {
    return !!(el && el.animate) && !reducedMotion();
  }

  /* Apparition en fondu montant, décalée d'un élément à l'autre. fill
     « backwards » : l'état de départ tient pendant le délai, puis la main
     revient au CSS (les survols et transitions restent actifs). */
  function rise(els, opts) {
    opts = opts || {};
    var list = Array.prototype.filter.call(els || [], Boolean);
    list.forEach(function (el, i) {
      if (!canAnimate(el)) return;
      el.animate([
        { opacity: 0, transform: 'translate(' + (opts.x || 0) + 'px, ' + (opts.y == null ? 16 : opts.y) + 'px)' },
        { opacity: 1, transform: 'none' }
      ], { duration: opts.duration || 750, delay: (opts.delay || 0) + i * (opts.stagger == null ? 70 : opts.stagger), easing: EASE_OUT, fill: 'backwards' });
    });
  }

  /* Sortie en fondu glissé ; appelle done() une fois terminée. */
  function leave(el, dx, done) {
    if (!canAnimate(el) || el.hidden) { done(); return; }
    var anim = el.animate([
      { opacity: 1, transform: 'none' },
      { opacity: 0, transform: 'translateX(' + dx + 'px)' }
    ], { duration: 260, easing: EASE_IN, fill: 'forwards' });
    anim.onfinish = function () { done(); anim.cancel(); };
  }

  /* Titre découpé en mots, chacun glissant hors d'un masque. */
  function splitWords(el) {
    if (!el || el.dataset.rqSplitDone) return;
    el.dataset.rqSplitDone = 'true';
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = '';
    words.forEach(function (w, i) {
      var outer = document.createElement('span');
      outer.className = 'shorae-rq__word';
      outer.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.textContent = w;
      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function playWords(el, delay) {
    if (!el) return;
    el.querySelectorAll('.shorae-rq__word > span').forEach(function (w, i) {
      if (!canAnimate(w)) return;
      w.animate([
        { transform: 'translateY(105%)' },
        { transform: 'none' }
      ], { duration: 1000, delay: (delay || 0) + i * 90, easing: EASE_OUT, fill: 'backwards' });
    });
  }

  function loadingLines(a) {
    var skin = {
      seche: 'Une peau qui tiraille a d’abord besoin de confort…',
      grasse: 'Une peau qui brille demande de la légèreté…',
      normale: 'Une peau équilibrée, on la garde ainsi…'
    }[a.type] || 'Nous tenons compte de votre peau…';
    return ['Nous lisons vos réponses…', skin, 'Nous composons votre routine, geste après geste…'];
  }

  /* --- Recommandation ------------------------------------------------------ */

  function buildRoutine(a) {
    var light = a.type === 'grasse';
    var full = a.temps === 'complet';
    var picks = { cleanser: true, spf: true };

    /* Une peau qui brille n'a pas de crème : l'essence suffit à l'hydrater. */
    if (light) picks.essence = true; else picks.cream = true;
    if (full) picks.essence = true;

    var extras = [];
    a.prio.forEach(function (p) {
      if (p === 'hydratation') { extras.push('essence'); if (full) extras.push('mist'); }
      if (p === 'eclat') extras.push('vitc');
      if (p === 'age') extras.push('antiage');
      if (p === 'yeux') extras.push('eye');
    });

    /* « L'essentiel » : un seul soin ciblé, celui de la première priorité. */
    if (!full) {
      var first = extras.filter(function (r) { return !picks[r]; })[0];
      extras = first ? [first] : [];
    }

    extras.forEach(function (r) { picks[r] = true; });
    return ORDER.filter(function (r) { return picks[r]; });
  }

  function reason(role, a) {
    var sensitive = a.sens === 'oui';
    var hasPrio = function (p) { return a.prio.indexOf(p) !== -1; };

    switch (role) {
      case 'cleanser':
        return sensitive
          ? 'Nettoie sans agresser une peau qui réagit : la base de tout le reste.'
          : 'Nettoie en douceur, matin et soir : la base de tout le reste.';
      case 'essence':
        if (a.type === 'grasse') return 'Hydrate sans alourdir : elle remplace la crème sur une peau qui brille.';
        if (hasPrio('hydratation')) return 'Acide hyaluronique et prébiotiques, pour le confort que vous recherchez.';
        return 'Prépare la peau à recevoir les soins suivants.';
      case 'mist':
        return 'Pour réhydrater dans la journée, au bureau comme en déplacement.';
      case 'vitc':
        return 'Pour raviver l’éclat d’un teint terne, le matin sous la protection solaire.';
      case 'antiage':
        return 'Le soin du soir des premiers signes de l’âge, avec une alternative végétale au rétinol.';
      case 'eye':
        return 'Une zone plus fine, qui mérite son propre soin.';
      case 'cream':
        return a.type === 'seche'
          ? 'Votre peau tiraille : la crème qui renforce la barrière et apporte le confort.'
          : 'Scelle l’hydratation et protège la barrière cutanée.';
      case 'spf':
        return 'Le dernier geste de chaque matin, toute l’année.';
    }
    return '';
  }

  function notesFor(a, roles, products) {
    var notes = [];
    var name = function (role) { return products[role] ? products[role].title : ''; };

    if (a.prio.indexOf('imperfections') !== -1) {
      notes.push({
        tone: 'honest',
        text: 'Shorae est pensé pour les peaux sensibles et la barrière cutanée : nous ne proposons pas de soin contre les imperfections. '
          + 'Cette routine respecte votre peau sans l’assécher, mais pour une acné installée, un dermatologue saura mieux vous orienter.'
      });
    }

    if (a.type === 'grasse' && roles.indexOf('essence') !== -1) {
      notes.push({ text: 'Pas de crème dans votre routine : ' + name('essence') + ' suffit à hydrater une peau qui brille, sans l’alourdir.' });
    }

    if (roles.indexOf('vitc') !== -1 && a.sens === 'oui') {
      notes.push({ text: name('vitc') + ' : commencez un matin sur deux, puis tous les jours si votre peau reste confortable.' });
    }

    if (a.sens === 'oui' && roles.length > 3) {
      notes.push({ text: 'Votre peau réagit facilement : introduisez un nouveau soin à la fois, à quelques jours d’intervalle.' });
    }

    return notes;
  }

  function headline(a, count) {
    var type = { seche: 'sèche', grasse: 'mixte à grasse', normale: 'équilibrée' }[a.type];
    var sens = { oui: ' et sensible', parfois: ', parfois réactive', non: '' }[a.sens];
    return count + ' soins pour une peau ' + type + sens;
  }

  function summary(a) {
    var prios = a.prio.filter(function (p) { return p !== 'simple'; }).map(function (p) { return PRIO_LABEL[p]; });
    var focus = prios.length ? 'Priorité à ' + prios.join(' et ') + '. ' : '';
    var mode = a.temps === 'complet' ? 'Une routine complète, matin et soir.' : 'L’essentiel, sans superflu.';
    return focus + mode;
  }

  /* --- Encodage des réponses (URL de partage, reprise après envoi du formulaire) */

  function encode(a) {
    return [a.type, a.sens, a.prio.join('-'), a.temps].join('.');
  }

  function decode(str) {
    if (!str || typeof str !== 'string') return null;
    var parts = str.split('.');
    if (parts.length !== 4) return null;

    var a = { type: parts[0], sens: parts[1], prio: parts[2] ? parts[2].split('-') : [], temps: parts[3] };

    if (VALID.type.indexOf(a.type) === -1) return null;
    if (VALID.sens.indexOf(a.sens) === -1) return null;
    if (VALID.temps.indexOf(a.temps) === -1) return null;
    if (!a.prio.length || a.prio.length > MAX_PRIO) return null;
    for (var i = 0; i < a.prio.length; i++) {
      if (VALID.prio.indexOf(a.prio[i]) === -1) return null;
    }
    return a;
  }

  function store(a) {
    try { sessionStorage.setItem(STORE_KEY, encode(a)); } catch (e) { /* stockage indisponible : sans conséquence */ }
  }

  function restore() {
    try { return decode(sessionStorage.getItem(STORE_KEY)); } catch (e) { return null; }
  }

  /* --- Composant ----------------------------------------------------------- */

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function setup(root) {
    if (root.dataset.rqReady === 'true') return;
    root.dataset.rqReady = 'true';

    var products = readJSON(root, '[data-rq-products]') || {};
    var cfg = readJSON(root, '[data-rq-config]') || {};
    /* Remise dégressive : plusieurs paliers { code, percent, min }, le plus
       élevé atteint s'applique. Un palier sans code ou à 0 % est ignoré.
       Compatibilité : l'ancien réglage à code unique devient un palier. */
    var tiers = Array.isArray(cfg.tiers) ? cfg.tiers.slice() : [];
    if (!tiers.length && cfg.discountCode) {
      tiers.push({ code: cfg.discountCode, percent: cfg.discountPercent, min: cfg.minItems });
    }
    tiers = tiers
      .map(function (t) { return { code: String(t.code || '').trim(), percent: Number(t.percent) || 0, min: Number(t.min) || 1 }; })
      .filter(function (t) { return t.code && t.percent > 0; })
      .sort(function (x, y) { return x.min - y.min; });
    var discountOn = tiers.length > 0;

    /* Palier atteint pour n soins (le dernier dont le minimum est atteint),
       et palier suivant, pour dire combien il manque. */
    function tierFor(n) {
      var hit = null;
      tiers.forEach(function (t) { if (n >= t.min && (!hit || t.percent >= hit.percent)) hit = t; });
      return hit;
    }
    function nextTier(n) {
      var current = tierFor(n);
      return tiers.filter(function (t) { return t.min > n && (!current || t.percent > current.percent); })[0] || null;
    }

    var intro = root.querySelector('[data-rq-intro]');
    var quiz = root.querySelector('[data-rq-quiz]');
    var result = root.querySelector('[data-rq-result]');
    var fieldsets = STEPS.map(function (s) { return quiz.querySelector('[data-rq-q="' + s + '"]'); });
    var progress = root.querySelector('[data-rq-progress]');
    var stepLabel = root.querySelector('[data-rq-step-label]');
    var nextBtn = root.querySelector('[data-rq-next]');
    var backBtn = root.querySelector('[data-rq-back]');
    var addBtn = root.querySelector('[data-rq-add]');
    var errorEl = root.querySelector('[data-rq-error]');
    var listEl = root.querySelector('[data-rq-list]');
    var totalEl = root.querySelector('[data-rq-total]');
    var emailForm = root.querySelector('.shorae-rq__email-form');
    var nav = root.querySelector('.shorae-rq__nav');
    var nextLabel = root.querySelector('[data-rq-next-label]');
    var loading = root.querySelector('[data-rq-loading]');
    var loadingText = root.querySelector('[data-rq-loading-text]');
    var heroTitle = root.querySelector('[data-rq-split]');
    var busy = false;
    var loadTimers = [];

    var money;
    try {
      money = new Intl.NumberFormat(cfg.locale || 'fr', { style: 'currency', currency: cfg.currency || 'EUR' });
    } catch (e) {
      money = { format: function (v) { return v.toFixed(2) + ' €'; } };
    }
    var fmt = function (cents) { return money.format(cents / 100); };

    var answers = { type: null, sens: null, prio: [], temps: null };
    var step = 0;
    var routine = [];
    var autoTimer = null;

    function answered(i) {
      var key = STEPS[i];
      return key === 'prio' ? answers.prio.length > 0 : !!answers[key];
    }

    function setStage(name) {
      root.dataset.stage = name;
    }

    function show(screen) {
      intro.hidden = screen !== 'intro';
      quiz.hidden = screen !== 'quiz';
      if (loading) loading.hidden = screen !== 'loading';
      result.hidden = screen !== 'result';
      if (screen !== 'quiz') setStage(screen);
    }

    function enterIntro() {
      root.classList.remove('is-ready');
      void root.offsetWidth;
      root.classList.add('is-ready');
      playWords(heroTitle, 250);
      rise(intro.querySelectorAll('.shorae-rq__eyebrow, .shorae-rq__lede, [data-rq-start], .shorae-rq__meta'), { delay: 150, stagger: 120, duration: 900 });
    }

    function updateNav(i, reveal) {
      var multi = STEPS[i] === 'prio';
      nextBtn.disabled = !answered(i);
      if (nextLabel) nextLabel.textContent = i === STEPS.length - 1 ? 'Voir ma routine' : 'Suivant';
      /* Choix unique : la réponse fait avancer seule, le bouton n'apparaît
         que pour revenir sur une réponse déjà donnée. */
      if (nav) nav.classList.toggle('is-hidden', !(multi || (reveal && answered(i))));
    }

    function goTo(i, focus, dir) {
      dir = dir || 1;
      var current = fieldsets[step];
      var target = fieldsets[i];
      var fromOther = current && current !== target && !current.hidden;

      function enter() {
        step = i;
        fieldsets.forEach(function (fs, idx) { fs.hidden = idx !== i; });
        setStage(STEPS[i]);
        progress.style.width = ((i + 1) / STEPS.length * 100) + '%';
        stepLabel.innerHTML = '<span aria-hidden="true"><b>0' + (i + 1) + '</b> / 0' + STEPS.length + '</span>'
          + '<span class="shorae-rq__sr">Question ' + (i + 1) + ' sur ' + STEPS.length + '</span>';
        updateNav(i, true);

        /* Si la question précédente a fait défiler la page, on remonte au
           début du quiz pour que la nouvelle question soit vue en entier. */
        var top = root.getBoundingClientRect().top;
        if (top < -8) root.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });

        rise([target.querySelector('legend')], { x: 28 * dir, y: 0, duration: 800 });
        rise([target.querySelector('.shorae-rq__hint')], { delay: 80, duration: 800 });
        rise(target.querySelectorAll('.shorae-rq__opt'), { delay: 140, stagger: 65, y: 18 });
        if (nav && !nav.classList.contains('is-hidden')) rise([nav], { delay: 300 });

        if (focus !== false) {
          var legend = target.querySelector('legend');
          if (legend) legend.focus({ preventScroll: true });
        }
        busy = false;
      }

      busy = true;
      if (fromOther) leave(current, -28 * dir, enter);
      else enter();
    }

    function next() {
      if (busy || !answered(step)) return;
      if (step < STEPS.length - 1) goTo(step + 1, true, 1);
      else showResult();
    }

    function back() {
      clearTimeout(autoTimer);
      if (busy) return;
      if (step === 0) {
        busy = true;
        leave(quiz, 28, function () { busy = false; show('intro'); enterIntro(); });
        return;
      }
      goTo(step - 1, true, -1);
    }

    /* Choix unique : on avance tout seul, après un court temps pour que la
       sélection soit perçue. Choix multiple : bouton « Suivant ». */
    quiz.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.name) return;

      if (input.type === 'radio') {
        answers[input.name] = input.value;
        nextBtn.disabled = false;
        var label = input.closest('.shorae-rq__opt');
        if (label) {
          label.classList.remove('is-picked');
          void label.offsetWidth;
          label.classList.add('is-picked');
        }
        clearTimeout(autoTimer);
        /* Le temps de voir le choix se marquer avant de passer à la suite. */
        autoTimer = setTimeout(next, reducedMotion() ? 150 : 560);
        return;
      }

      if (input.name === 'prio') {
        var boxes = Array.prototype.slice.call(quiz.querySelectorAll('input[name="prio"]'));

        if (input.checked && input.value === 'simple') {
          boxes.forEach(function (b) { if (b !== input) b.checked = false; });
        } else if (input.checked) {
          boxes.forEach(function (b) { if (b.value === 'simple') b.checked = false; });
          var checked = boxes.filter(function (b) { return b.checked; });
          if (checked.length > MAX_PRIO) input.checked = false;
        }

        answers.prio = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
        nextBtn.disabled = answers.prio.length === 0;
      }
    });

    nextBtn.addEventListener('click', next);
    backBtn.addEventListener('click', back);

    root.querySelector('[data-rq-start]').addEventListener('click', function () {
      if (busy) return;
      busy = true;
      leave(intro, -28, function () {
        show('quiz');
        rise(root.querySelectorAll('.shorae-rq__top, .shorae-rq__progress'), { y: -8, duration: 600 });
        goTo(0, true, 1);
      });
    });

    root.querySelector('[data-rq-restart]').addEventListener('click', function () {
      answers = { type: null, sens: null, prio: [], temps: null };
      quiz.reset();
      try { history.replaceState(null, '', location.pathname); } catch (e) { /* rien */ }
      loadTimers.forEach(clearTimeout);
      show('quiz');
      step = 0;
      fieldsets.forEach(function (fs) { fs.hidden = true; });
      goTo(0, true, 1);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* --- Résultat --------------------------------------------------------- */

    function syncForm(a) {
      Array.prototype.forEach.call(quiz.elements, function (el) {
        if (!el.name) return;
        if (el.name === 'prio') el.checked = a.prio.indexOf(el.value) !== -1;
        else if (el.type === 'radio') el.checked = a[el.name] === el.value;
      });
    }

    function renderList(a) {
      listEl.innerHTML = '';

      routine.forEach(function (role) {
        var p = products[role];
        var li = document.createElement('li');
        li.className = 'shorae-rq__item';

        var img = p.image
          ? '<img class="shorae-rq__item-img" src="' + p.image + '" alt="" width="64" height="64" loading="lazy">'
          : '<span class="shorae-rq__item-img" aria-hidden="true"></span>';

        li.innerHTML = img
          + '<div class="shorae-rq__item-body">'
          +   '<span class="shorae-rq__when"></span>'
          +   '<a class="shorae-rq__name"></a>'
          +   '<span class="shorae-rq__why"></span>'
          + '</div>'
          + '<label class="shorae-rq__pick">'
          +   '<span class="shorae-rq__price"></span>'
          +   '<span class="shorae-rq__toggle"><input type="checkbox" checked><span>Inclure</span></span>'
          + '</label>';

        li.querySelector('.shorae-rq__when').textContent = WHEN[role];
        var nameEl = li.querySelector('.shorae-rq__name');
        nameEl.textContent = p.title;
        nameEl.href = p.url;
        li.querySelector('.shorae-rq__why').textContent = reason(role, a);
        li.querySelector('.shorae-rq__price').textContent = fmt(p.price);

        var box = li.querySelector('input');
        box.dataset.rqRole = role;
        box.setAttribute('aria-label', 'Inclure ' + p.title);
        box.addEventListener('change', function () {
          li.classList.toggle('is-off', !box.checked);
          updateTotal();
        });

        listEl.appendChild(li);
      });
    }

    function pickedRoles() {
      return Array.prototype.filter.call(listEl.querySelectorAll('input[data-rq-role]'), function (b) { return b.checked; })
        .map(function (b) { return b.dataset.rqRole; });
    }

    function updateTotal(silent) {
      var roles = pickedRoles();
      var subtotal = roles.reduce(function (sum, r) { return sum + products[r].price; }, 0);
      var tier = tierFor(roles.length);
      var next = nextTier(roles.length);
      var eligible = !!tier;
      var discount = eligible ? Math.round(subtotal * tier.percent / 100) : 0;

      addBtn.disabled = roles.length === 0;

      if (!roles.length) {
        totalEl.textContent = 'Sélectionnez au moins un soin.';
        return;
      }

      if (eligible) {
        totalEl.innerHTML = '<strong></strong> <s></s> <span class="shorae-rq__badge"></span>';
        totalEl.querySelector('strong').textContent = fmt(subtotal - discount);
        totalEl.querySelector('s').textContent = fmt(subtotal);
        totalEl.querySelector('.shorae-rq__badge').textContent = '−' + tier.percent + ' % sur votre routine';
      } else {
        totalEl.innerHTML = '<strong></strong>';
        totalEl.querySelector('strong').textContent = fmt(subtotal);
      }

      if (!silent) rise([totalEl.querySelector('strong')], { y: 6, duration: 450 });

      /* On n'incite à ajouter un soin que si la routine en propose un de
         décoché : le quiz ne permet pas d'en ajouter d'autres. */
      var listed = listEl.querySelectorAll('input[data-rq-role]').length;
      if (next && next.min <= listed) {
        var missing = next.min - roles.length;
        var hint = document.createElement('span');
        hint.className = 'shorae-rq__hint-inline';
        hint.textContent = 'Gardez ' + missing + ' soin' + (missing > 1 ? 's' : '') + ' de plus pour '
          + (eligible ? 'passer à −' : 'bénéficier de −') + next.percent + ' %.';
        totalEl.appendChild(document.createTextNode(' '));
        totalEl.appendChild(hint);
      }
    }

    function renderNotes(a) {
      var notesEl = root.querySelector('[data-rq-notes]');
      notesEl.innerHTML = '';
      notesFor(a, routine, products).forEach(function (n) {
        var li = document.createElement('li');
        li.className = 'shorae-rq__note' + (n.tone === 'honest' ? ' shorae-rq__note--honest' : '');
        li.textContent = n.text;
        notesEl.appendChild(li);
      });

      var missing = buildRoutine(a).filter(function (r) { return routine.indexOf(r) === -1; });
      if (missing.length) {
        var li = document.createElement('li');
        li.className = 'shorae-rq__note';
        li.textContent = 'Un soin de votre routine est momentanément indisponible ; il n’apparaît pas ci-dessous.';
        notesEl.appendChild(li);
      }
    }

    function showResult(opts) {
      opts = opts || {};
      var a = answers;

      routine = buildRoutine(a).filter(function (r) { return products[r] && products[r].available && products[r].variantId; });

      root.querySelector('[data-rq-headline]').textContent = headline(a, routine.length);
      root.querySelector('[data-rq-summary]').textContent = summary(a);
      renderNotes(a);
      renderList(a);
      updateTotal(true);
      errorEl.hidden = true;
      store(a);

      try {
        var url = new URL(location.href);
        url.searchParams.delete('customer_posted');
        url.searchParams.set('routine', encode(a));
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) { /* rien */ }

      /* Reprise (lien partagé, retour du formulaire) : pas de mise en scène. */
      if (opts.instant || !loading || reducedMotion()) {
        show('result');
        revealResult(opts);
        return;
      }

      /* Courte mise en scène : la routine « se compose » sous les yeux. */
      busy = true;
      leave(quiz, -28, function () {
        show('loading');
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        rise([loading.querySelector('.shorae-rq__orb')], { y: 0, duration: 900 });

        var lines = loadingLines(a);
        var STEP_MS = 800;
        loadTimers.forEach(clearTimeout);
        loadTimers = [];
        lines.forEach(function (line, i) {
          loadTimers.push(setTimeout(function () {
            loadingText.textContent = line;
            rise([loadingText], { y: 10, duration: 600 });
          }, i * STEP_MS));
        });
        loadTimers.push(setTimeout(function () {
          leave(loading, 0, function () {
            busy = false;
            show('result');
            revealResult(opts);
          });
        }, lines.length * STEP_MS + 200));
      });
    }

    function revealResult(opts) {
      var head = root.querySelector('.shorae-rq__result-head');
      rise(head ? head.children : [], { stagger: 110, duration: 900 });
      rise(root.querySelectorAll('.shorae-rq__note'), { delay: 350, stagger: 90 });
      rise(listEl.children, { delay: 450, stagger: 120, y: 22, duration: 900 });
      var after = 450 + listEl.children.length * 120;
      rise(root.querySelectorAll('.shorae-rq__buy, .shorae-rq__email, .shorae-rq__fine--end'), { delay: after, stagger: 110 });

      if (opts.scrollTo) {
        opts.scrollTo.scrollIntoView({ block: 'center' });
      } else {
        root.scrollIntoView({ behavior: opts.instant ? 'auto' : 'smooth', block: 'start' });
        root.querySelector('[data-rq-headline]').focus({ preventScroll: true });
      }
    }

    /* --- Ajout au panier -------------------------------------------------- */

    addBtn.addEventListener('click', function () {
      var roles = pickedRoles();
      if (!roles.length) return;

      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      errorEl.hidden = true;

      var items = roles.map(function (r) { return { id: products[r].variantId, quantity: 1 }; });

      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (body) { throw new Error(body.description || body.message || 'Erreur'); });
          return res.json();
        })
        .then(function () {
          var cart = cfg.cartUrl || '/cart';
          var tier = tierFor(roles.length);
          if (tier) {
            /* Le lien /discount/CODE applique la remise à la session, puis
               redirige : le client n'a aucun code à saisir. */
            var base = (cfg.root || '/').replace(/\/?$/, '/');
            location.href = base + 'discount/' + encodeURIComponent(tier.code) + '?redirect=' + encodeURIComponent(cart);
          } else {
            location.href = cart;
          }
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
          errorEl.textContent = 'Impossible d’ajouter la routine au panier : ' + err.message;
          errorEl.hidden = false;
        });
    });

    /* --- E-mail ----------------------------------------------------------- */

    if (emailForm) {
      emailForm.addEventListener('submit', function () {
        var tags = ['quiz-routine', 'quiz-peau-' + answers.type, 'quiz-sensible-' + answers.sens, 'quiz-' + answers.temps]
          .concat(answers.prio.map(function (p) { return 'quiz-prio-' + p; }));
        var field = emailForm.querySelector('[data-rq-tags]');
        if (field) field.value = tags.join(', ');
        store(answers);
      });
    }

    /* --- Démarrage : reprise éventuelle ----------------------------------- */

    var params = new URLSearchParams(location.search);
    var restored = decode(params.get('routine'));
    var emailState = root.querySelector('[data-rq-email-state]');

    /* Après envoi du formulaire, Shopify recharge la page : on retrouve la
       routine dans la session pour ne pas renvoyer la cliente au début. */
    if (!restored && (emailState || params.get('customer_posted'))) restored = restore();

    if (restored) {
      answers = restored;
      syncForm(answers);
      showResult({ instant: true, scrollTo: emailState ? root.querySelector('.shorae-rq__email') : null });
    } else {
      splitWords(heroTitle);
      show('intro');
      enterIntro();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-shorae-rq]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  /* Exposé pour les tests ; sans effet sur la page. */
  window.ShoraeRoutineQuiz = { buildRoutine: buildRoutine, decode: decode, encode: encode };
})();
